/*
 * Copyright (C) 2025-2026 The Klangmotor Authors (see AUTHORS.MD)
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

@file:KlangScript.Library(KlangScriptLibraries.STDLIB)

package io.peekandpoke.klang.script.stdlib

import io.peekandpoke.klang.script.annotations.KlangScript
import io.peekandpoke.klang.script.annotations.KlangScriptLibraries

/**
 * The mathematical constant π (pi), the ratio of a circle's circumference to its diameter.
 *
 * Equivalent to `Math.PI`. Provided as a top-level constant for convenience.
 *
 * ```KlangScript(Executable)
 * PI  // 3.141592653589793
 * ```
 *
 * @category math
 * @tags constant, math, pi
 */
@KlangScript.Constant
val PI: Double = kotlin.math.PI

/**
 * Euler's number e, the base of the natural logarithm.
 *
 * Equivalent to `Math.E`. Provided as a top-level constant for convenience.
 *
 * ```KlangScript(Executable)
 * E  // 2.718281828459045
 * ```
 *
 * @category math
 * @tags constant, math, euler
 */
@KlangScript.Constant
val E: Double = kotlin.math.E
